import { Stack, Typography } from "@mui/material";
import DialogAnimate from "src/components/animate/DialogAnimate";

import ChangePasswordForm from "./ChangePasswordForm";
import Context from "./context";

type Props = {
	show: boolean;
	onClose: () => void;
};

export default function ChangePasswordDialog({ show, onClose }: Props) {
	return (
		<DialogAnimate maxWidth={"xs"} onClose={onClose} open={show}>
			<Context.Provider value={{ onClose }}>
				<Stack sx={{ p: 3 }}>
					<Typography variant='subtitle1' fontSize={21}>
						{"Cambiar contraseña"}
					</Typography>
					<ChangePasswordForm />
				</Stack>
			</Context.Provider>
		</DialogAnimate>
	);
}
